"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ao_compose = void 0;
exports.ao_compose = `
uniform highp sampler2D inputTexture;
uniform highp sampler2D depthTexture;
uniform float power;
uniform vec3 color;

void mainImage(const in vec4 inputColor, const in vec2 uv, out vec4 outputColor) {
    float unpackedDepth = textureLod(depthTexture, uv, 0.).r;

    float ao = unpackedDepth > 0.99975 ? 1.0 : textureLod(inputTexture, uv, 0.0).a;
    ao = pow(ao, power);

    vec3 aoColor = mix(color, vec3(1.), ao);

    aoColor *= inputColor.rgb;

    outputColor = vec4(aoColor, inputColor.a);
}
`;
//# sourceMappingURL=ao_compose.js.map